<template>
  <div>
    <div class="mb-1">
      <div class="note-title">
        <div class="row">
          <div class="d-flex align-items-center col-md-4 col-lg-3">
            <span>{{ note.label }} </span>
          </div>
          <div class="col-md-8 col-lg-9">
            <AsyncSelect
              placeholder="Select Notes"
              v-model="noteNameList"
              :api-service="noteNameByType"
              :additional-query="{ type: note.value }"
              :label="'name'"
              :reduce="item => item"
              :is-new-added="true"
              :is-multiple="true"
              @newAdd="handleNewAdded"
            />
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, watch, ref } from "vue";
import { useRoute } from "vue-router";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleHospital from '@/services/modules/hospital';

const { noteNameByType, storeNote } = handleHospital();
const route = useRoute();

const props = defineProps({
  note: Object,
  index: Number,
});

const internalNoteNames = ref([]);

watch(
  () => props.note.note_names,
  (newVal) => {
    internalNoteNames.value = newVal ? newVal.map(name => ({ name })) : [];
  },
  { immediate: true }
);

const noteNameList = computed({
  get() {
    return internalNoteNames.value;
  },
  set(newVal) {
    internalNoteNames.value = newVal;
  }
});

const handleNewAdded = async (newOption) => {
  const res = await storeNote({
    company_id: route.params.companyId,
    type: props.note.value,
    name: newOption.name,
    status: 'active',
  });
  if(!res.status) {
    console.log('Something went wrong');
    return;
  }
};

defineExpose({
  getNoteData: () => ({
    id: props.note.id || null,
    type: props.note.value,
    new_notes: [],
    note: JSON.stringify(noteNameList.value.map(n => n.name))
  })
});
</script>

<style>
.note-head {
    display: flex;
    margin-top: 2%;
    justify-content: space-between;
    margin-bottom: 1%;
}
.note-body .card {
    background: #f9f9f9;
    min-height: 100px;
    margin-bottom: 1rem;
}

.note-body .card-body {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}

.note-section {
    margin-top: 2%;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    width: 96%;
    margin-left: 2%;
}
</style>